export default __webpack_public_path__ + "static/media/tete59.6277a45f.png";